import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Rect } from '../pixiComponents/rect';
export const WinningHandNameBackground = ({ bounds, borderColorNum, backgroundColorNum }) => {
    const { x, y, w, h } = bounds;
    return (_jsx(Rect, { x: x, y: y, w: w, h: h, fillColor: backgroundColorNum, lineColor: borderColorNum, lineWidth: 2, radius: 30 }));
};
